import { useNavigate } from 'react-router-dom';

import { Wrapper } from '@american-autonomy/ag-ui';

import CaptionText from 'components/text/CaptionText';

import usePageRoutes from 'hooks/usePageRoutes';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneActivityLink: FunctionComponent<Props> = ({
    className = '',
    droneId,
    testId = TEST_ID
}) => {
    const { VIEW_RECENT_ACTIVITY } = useTranslation();
    const navigate = useNavigate();
    const { droneDetailsPage } = usePageRoutes();

    const handleClick = (clickEvent?: { stopPropagation: VoidFunction }) => {
        clickEvent?.stopPropagation();
        navigate(droneDetailsPage(droneId));
    };

    return (
        <Wrapper
            className={`${className} ${styles.droneActivityLink}`}
            onClick={handleClick}
            testId={testId}>
            <CaptionText text={VIEW_RECENT_ACTIVITY} />
        </Wrapper>
    );
};

export default DroneActivityLink;
